import React from 'react';
import { LeftNavigationBar } from '../LeftNavigationBar/LeftNavigationBar';
import { UserDetails } from '../UserDetails';
import { MainContent, AppContainer, ContentWrapper } from './AppLayout.styles';
import TopNavigationHeader from '../TopNavigationHeader';

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <AppContainer>
        <UserDetails />
        <TopNavigationHeader />
        <ContentWrapper>
          <LeftNavigationBar />
          <MainContent>{children}</MainContent>
        </ContentWrapper>
    </AppContainer>
  );
}
